import clsx from 'clsx';
import React, { Children } from 'react';
import { Spinner } from '@pillexa-dev/ui';

export type ButtonProps = {
  variant: 'primary' | 'secondary' | 'ghost' | 'danger' | 'nuclear' | 'outline' | 'teal';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  active?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'large', loading = false, children, active = false, ...attributes }, ref) => {
    const handleClick = (e) => {
      if (!loading && attributes.onClick) {
        attributes.onClick(e);
      }
    };

    const variantClassname = clsx({
      ['btn-primary']: variant === 'primary',
      ['btn-secondary']: variant === 'secondary',
      ['btn-ghost']: variant === 'ghost',
      ['btn-danger']: variant === 'danger',
      ['btn-nuclear']: variant === 'nuclear',
      ['btn-outline']: variant === 'outline',
      ['btn-teal']: variant === 'teal',
      ['btn-teal-active']: variant === 'teal' && active,
    });

    const sizeClassname = clsx({
      ['btn-large']: size === 'large',
      ['btn-medium']: size === 'medium',
      ['btn-small']: size === 'small',
    });

    return (
      <button
        {...attributes}
        className={clsx('btn', variantClassname, sizeClassname, attributes.className)}
        disabled={attributes.disabled || loading}
        ref={ref}
        onClick={handleClick}
      >
        {loading ? (
          <Spinner size={size} variant={'secondary'} />
        ) : (
          Children.map(children, (child, i) => {
            return (
              <span key={i} className="mr-xsmall last:mr-0">
                {child}
              </span>
            );
          })
        )}
      </button>
    );
  },
);

export default Button;
